import Footer from '@common/components/Footer';
import Header from '@common/components/Header';
import { Box, Flex, FlexProps } from '@radix-ui/themes';
import { AppRouteHandle } from '@router';
import { PropsWithChildren } from 'react';
import { UIMatch, useMatches } from 'react-router-dom';

import { AnimatedBackground } from '@common/components/AnimatedBackground';
import classNames from 'classnames';
import styles from './Layout.module.css';

// const AnimatedBackground = lazy(() =>
//     import('@common/components/AnimatedBackground').then((module) => ({
//         default: module.AnimatedBackground,
//     })),
// );

const LayoutContainer = ({ children }: PropsWithChildren) => {
    const matches = useMatches() as UIMatch<unknown, AppRouteHandle>[];

    const hideParticles = matches.some(
        (match) => match.handle?.hideGlobalParticles === true,
    );

    return (
        <Flex
            direction={'column'}
            height={'100vh'}
            width={'100%'}
            px={'4'}
            position={'relative'}
            overflow={'hidden'}
        >
            <Box
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    zIndex: 0,
                    pointerEvents: 'none',
                    opacity: hideParticles ? 0 : 1,
                    visibility: hideParticles ? 'hidden' : 'visible',
                    transition:
                        'opacity 0.6s ease-in-out, visibility 0.6s ease-in-out',
                }}
            >
                {/* <Suspense fallback={null}> */}
                <AnimatedBackground />
                {/* </Suspense> */}
            </Box>

            <Box flexShrink={'0'} style={{ position: 'relative', zIndex: 1 }}>
                <Header />
            </Box>

            <Flex
                direction={'column'}
                flexGrow={'1'}
                overflowY={'auto'}
                style={{ position: 'relative', zIndex: 1 }}
            >
                <Box className={styles.container}>{children}</Box>
            </Flex>

            <Box flexShrink={'0'} style={{ position: 'relative', zIndex: 1 }}>
                <Footer />
            </Box>
        </Flex>
    );
};

type LayoutContentProps = FlexProps &
    PropsWithChildren & {
        centered?: boolean;
    };

const LayoutContent = ({
    children,
    centered = false,
    ...rest
}: LayoutContentProps) => {
    return (
        <Flex
            direction={'column'}
            className={classNames(
                styles.contentFill,
                centered && styles.contentCentered,
            )}
            {...rest}
        >
            {children}
        </Flex>
    );
};

type LayoutDynamicContentProps = FlexProps &
    PropsWithChildren & {
        scrollable?: boolean;
    };

const LayoutDynamicContent = ({
    children,
    scrollable = false,
    ...rest
}: LayoutDynamicContentProps) => {
    return (
        <Flex
            direction={'column'}
            className={classNames(
                styles.dynamicBase,
                scrollable
                    ? styles.dynamicScrollable
                    : styles.dynamicNonScrollable,
            )}
            width={'100%'}
            {...rest}
        >
            {children}
        </Flex>
    );
};

export const Layout = Object.assign(LayoutContainer, {
    Content: LayoutContent,
    Dynamic: LayoutDynamicContent,
});
